import React from "react";

export interface INotificationIconProps {
  top?: number;
  left?: number;
  right?: number;
  bottom?: number;
  className?: string;
}

function NotificationIcon(props: INotificationIconProps) {
  const { top, left, right, bottom } = props;

  return (
    <span style={{ position: "relative" }}>
      <span
        className={
          "notification-icon-pending " +
          (props.className ? props.className : "")
        }
        style={{ top, left, right, bottom }}
      ></span>
    </span>
  );
}

export default NotificationIcon;
